/**
 * Thin API client for backend endpoints.
 * Base URL from REACT_APP_API_URL environment variable.
 * All errors shown via react-hot-toast per shared-docs requirement.
 * Authenticated endpoints require idToken (COGNITO_USER_POOLS authorizer).
 */
import toast from 'react-hot-toast';
import { getStoredAuth } from './nativeAppleSignIn';

const BASE_URL = process.env.REACT_APP_API_URL || '';

function getAuthHeaders() {
  const auth = getStoredAuth();
  return auth?.idToken ? { Authorization: auth.idToken } : {};
}

async function request(path, options = {}) {
  const { silent, ...fetchOptions } = options;
  const url = `${BASE_URL}${path}`;
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders(), ...fetchOptions.headers },
    ...fetchOptions,
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: res.statusText }));
    const message = error.error || error.message || `API error: ${res.status}`;
    if (!silent) toast.error(message);
    throw new Error(message);
  }

  return res.json();
}

export function getSubscriptionStatus(userId) {
  return request(`/subscription/${encodeURIComponent(userId)}`, { silent: true });
}

export function deleteProfile(idToken) {
  return request('/profile', {
    method: 'DELETE',
    headers: { Authorization: idToken },
  });
}

export function startTrial() {
  return request('/trial', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}
